
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class BodyRegister3 extends Vue {
  @Prop({ default: [] })
  private items!: Array<any>;

  @Getter("twoColor")
  private twoColor!: { text: string; bg: string; border: string };

  private get twoBgColor() {
    return this.twoColor.bg;
  }
}
